export enum NaturezaContaContabil {
    Ativo = 0,
    Passivo = 1,
    PL = 2,
    Resultado = 3
}